export default __webpack_public_path__ + "static/media/ICONE-COURO-MACIO.470931cd.svg";